export const c_panel__main_MaxHeight = {
  "name": "--pf-v6-c-panel__main--MaxHeight",
  "value": "18.75rem",
  "var": "var(--pf-v6-c-panel__main--MaxHeight)"
};
export default c_panel__main_MaxHeight;